





















































import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class HotelFaq extends Vue {
  private itemsOf(path: string): Array<string> {
    const raw = this.$t(path);
    if (typeof raw !== "string" || !raw) return [];
    return raw.split("\n");
  }

  get step1Items(): Array<string> {
    return this.itemsOf("Administration.hotel.faq.step1.items");
  }
  get step2Items(): Array<string> {
    return this.itemsOf("Administration.hotel.faq.step2.items");
  }
  get step3Items(): Array<string> {
    return this.itemsOf("Administration.hotel.faq.step3.items");
  }
}
